import { render, staticRenderFns } from "./IconCompanies.vue?vue&type=template&id=4dba83d7&"
import script from "./IconCompanies.vue?vue&type=script&lang=ts&"
export * from "./IconCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports